import * as constant from "./constant";

const INITIAL_STATE = {
  loading: false,
  micOpen: false,
  historyChat: {
    data: {
      data: [
        {
          answer: null,
          createdDate: null,
          question: null,
        },
      ],
      pageNumber: 0,
    },
    httpStatus: 0,
  },
};

const homeReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case constant.LOADING:
      return Object.assign({}, state, {
        loading: action.payload,
      });
    case constant.MIC_OPEN:
      return Object.assign({}, state, {
        micOpen: action.payload,
      });
    case constant.HISTORY_CHAT:
      return Object.assign({}, state, {
        historyChat: action.payload,
      });
    default:
      return state;
  }
};

export default homeReducer;
